/* Toodete indeks — sections/product-index.liquid (09.10.2026).

   Ainus töö: kui hiir läheb reale või fookus jõuab reale, saab see rida,
   tema lavapilt ja allkiri klassi `is-active`. Kõik ülejäänu (sisenemine,
   ristfade, mis on nähtav millises režiimis) on CSS-is.

   `pointerenter` + `pointerType === 'mouse'`: puudutus ei tohi lava vahetada,
   sest puutel viib sama puudutus kohe tootelehele ja lava on seal niikuinii
   peidus. `focusin`, mitte `focus`: fookus jõuab rea sisse (nimi, ostunupp),
   mitte rea enda peale.

   Ilma JS-ita näitab lava esimest toodet (Liquid paneb `is-active` esimesele)
   ja kõik read on tavalised lingid. */
if (!customElements.get('product-index')) {
  customElements.define(
    'product-index',
    class ProductIndex extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-pindex-row]'));
        this.shots = Array.from(this.querySelectorAll('[data-pindex-shot]'));
        this.captions = Array.from(this.querySelectorAll('[data-pindex-caption]'));
        this.current = Math.max(
          0,
          this.rows.findIndex((row) => row.classList.contains('is-active'))
        );

        this.rows.forEach((row, index) => {
          // Hõljumise kavatsus (20.10.2026): vahetus alles 70 ms järel, et
          // nimede üle libisev kursor ei paneks lava vilkuma.
          row.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            clearTimeout(this.intent);
            this.intent = setTimeout(() => this.activate(index), 70);
          });
          row.addEventListener('pointerleave', () => clearTimeout(this.intent));
          row.addEventListener('focusin', () => this.activate(index));
        });
      }

      activate(index) {
        if (index === this.current) return;
        this.current = index;
        [this.rows, this.shots, this.captions].forEach((list) => {
          list.forEach((el, i) => el.classList.toggle('is-active', i === index));
        });
      }
    }
  );
}
